module.exports = __webpack_public_path__ + "img/advantage_icon_activity.0c8a1c0b.svg";